<div (click)="(click)" class="pointer-cursor"><i class="pi pi-trash"></i></div>
